import cx from "classnames";
import { useLayoutEffect, useRef, useState } from "react";
import styles from "@/interface/ContextMenu/ContextMenu.module.css";
import { getSubmenuPosition } from "@/interface/ContextMenu/helpers";
import type { MenuItem, Position } from "@/interface/ContextMenu/types";

type SubmenuProps = {
    items: NonNullable<MenuItem["submenu"]>;
    onClick: (code: string) => void;
};

export const Submenu = ({ items, onClick }: SubmenuProps) => {
    const submenuRef = useRef<HTMLDivElement | null>(null);
    const [position, setPosition] = useState<Position>({ x: 0, y: 0 });

    useLayoutEffect(() => {
        const submenu = submenuRef.current;
        if (!submenu) return;
        const alignBy = submenu.parentElement as HTMLElement | null;
        if (!alignBy) return;

        setPosition(getSubmenuPosition(submenu, alignBy));
    }, []);

    return (
        <div
            ref={submenuRef}
            className={styles.submenu}
            style={{
                position: "fixed",
                top: position.y,
                left: position.x,
            }}
        >
            {items.map((item) => (
                <button
                    key={item.name}
                    type="button"
                    className={cx(styles.contextMenuItem, styles.subMenuItem)}
                    onClick={() => onClick(item.name)}
                >
                    <p className={styles.contextMenuItemName}>{item.label}</p>
                    {item.shortCut && (
                        <p className={styles.contextMenuItemShortcut}>{item.shortCut}</p>
                    )}
                </button>
            ))}
        </div>
    );
};
